<template>
  <b-tab title="Documentos" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE DOCUMENTOS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterDocumentos(filtro)" :fields="fields.documento">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="documento-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pela descrição do documento."
              v-model="filtro"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <documento-modal ref="editor" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useDocumentoStore } from "@/stores/DocumentoStore";
import Documento from "@/models/Documento";
import TableFields from "@/tools/TableFields";
import DocumentoModal from "@/components/modals/inspecao/DocumentoModal";

export default {
  name: "DocumentoTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: "",
      documento: new Documento(),
    };
  },

  components: {
    "documento-modal": DocumentoModal,
  },

  methods: {
    adicionar() {
      this.documento = new Documento();
      this.$refs.editor.call(this.documento);
    },

    editar(documento) {
      this.$refs.editor.call(documento);
    },
  },

  setup() {
    const store = useSgcqStore();
    const documentoStore = useDocumentoStore();
    const { getFilterDocumentos } = storeToRefs(documentoStore);

    return {
      store,
      documentoStore,
      getFilterDocumentos,
    };
  },
};
</script>

<style lang="scss" scoped>
#documento-filter {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
